(ns dre.pages.my-searches.tags.views
  (:require
   [dre.app.events :as app-events]
   [dre.app.router :as router :refer [->route]]
   [dre.components.icon :refer [fa-icon icon svg]]
   [dre.components.inputs :refer [input-search]]
   [dre.components.table :refer [table]]
   [dre.modals.events :as-alias modals]
   [dre.pages.my-searches.tags.events :as-alias events]
   [dre.pages.my-searches.tags.utils :refer [tag-pill]]
   [dre.pages.my-searches.views :as my-searches]
   [dre.page-util :as page-util :refer [nbsp]]
   [dre.i18n.views :refer [tr]]
   [dre.i18n.events :as-alias i18n]
   [dre.utils :refer [restricted-role? roles-hash]]
   [dre.utils.query :as q]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def component-name :tags)

(defn tags-filter
  []
  [:div
   {:class (bem/be component-name :search-bar)}
   [input-search
    {:placeholder @(rf/subscribe [::i18n/translate "Find..."])
     :on-change (fn [e] (rf/dispatch [::events/tag-filter (str (.-value (.-target e)))]))
     :value @(rf/subscribe [::events/tag-filter])}]])

(defn view
  []
  (r/create-class
   {:component-will-unmount
    #(rf/dispatch [::events/tag-filter ""])
    :reagent-render
    (fn []
      (let [selected (r/atom [])
            user @(rf/subscribe [::app-events/user])
            restricted? (restricted-role? user)
            tags @(rf/subscribe [::events/tags])]
        [:div
         {:class component-name}
         [:div
          {:class (bem/be component-name :nav)}
          [my-searches/view]]
         [:div
          {:class (bem/be component-name :header)}
          [tags-filter]
          (when-not restricted?
            [:div
             {:class (bem/be component-name :add-new-saved-search)}
             [:button.button
              {:class (bem/bm :button [:light :medium])
               :on-click #(rf/dispatch [::modals/set-modal :my-searches.tags/edit {:data-edit nil}])}
              [icon :common :save]
              [tr "New Tag"]]])]
         [:div
          {:class (bem/be component-name :content)}
          [table
           {:columns [{:title [tr "Tag"]
                       :render (fn [{:keys [name owner color tag_uuid]}]
                                 [:div
                                  {:class :subject}
                                  [:div
                                   {:class (bem/be :subject :fragment)}
                                   [tag-pill {:name name
                                              :owner owner
                                              :color color}
                                    user]
                                   [:div
                                    {:class (bem/be :subject :actions)}
                                    [:a
                                     {:onClick #(rf/dispatch
                                                 [::router/redirect-to-path-with-query-params
                                                  (->route :search)
                                                  (:query-params (q/route {:query/type :articles
                                                                           :query/pills [{:pill/type :utag
                                                                                          :pill/query tag_uuid
                                                                                          :pill/owner owner}]}
                                                                          (roles-hash user)))])}
                                     [fa-icon :magnifying-glass]]]]]
                                 )
                       :dataIndex :name
                       :sorter :default}
                      {:title [tr "Description"]
                       :render (fn [{:keys [description]}]
                                 [:span description])}
                      {:title [tr "Owner"]
                       :render (fn [{:keys [owner_profile]}]
                                 [:a
                                  {:href (str "mailto:" (:email owner_profile))
                                   :target "_blank"}
                                  (:firstname owner_profile)
                                  nbsp
                                  (:lastname owner_profile)])
                       :dataIndex :owner
                       :sorter :default}
                      {:title ""
                       :render (fn [{:keys [name tag_uuid read_only owner] :as tag}]
                                 [:span
                                  {:class (bem/be component-name :action-buttons)}
                                  (when-not restricted?
                                    [:span
                                     {:onClick #(rf/dispatch [::modals/set-modal :my-searches.tags/copy {:data-copy tag}])}
                                     [fa-icon :copy]])
                                  (when-not (or read_only
                                                restricted?)
                                    [:span
                                     {:onClick #(rf/dispatch [::modals/set-modal :my-searches.tags/edit {:data-edit tag}])}
                                     [svg :common :edit]])
                                  (when-not restricted?
                                    [:span
                                     {:onClick #(rf/dispatch [::modals/set-modal :search.share/share  {:search-query {:query/type :articles
                                                                                                                      :query/pills [{:pill/type :utag
                                                                                                                                     :pill/query tag_uuid
                                                                                                                                     :pill/owner owner}]}}])}
                                     [svg :common :share]])
                                  (when-not restricted?
                                    [:span
                                     {:onClick #(rf/dispatch [::modals/set-modal :my-searches.tags/delete-confirm {:data-delete [{:title name
                                                                                                                                  :uuid tag_uuid}]}])}
                                     [fa-icon :trash-can]])])}]
            :dataSource tags
            :loading? @(rf/subscribe [::events/loading?])
            :rowSelection {:type "checkbox"
                           :onChange (fn [selected-row-keys selected-rows]
                                       (reset! selected selected-rows))}
            :rowKey (fn [element] (str (hash element)))
            :pagination {:defaultPageSize 10
                         :hideOnSinglePage true}}]]
         [:div
          {:class (bem/be component-name :footer)}
          (when-not restricted?
            [:div.remove-selection
             [:button.button
              {:class (bem/bm :button [:light :medium])
               :on-click #(rf/dispatch [::modals/set-modal :my-searches.tags/delete-confirm
                                        {:data-delete (mapv (fn [e]
                                                              (let [v (js->clj e :keywordize-keys true)]
                                                                (hash-map :title (get v :name)
                                                                          :uuid (get v :tag_uuid)))) @selected)}])}
              [fa-icon :trash-can]
              [tr "Delete Selection"]]])]]))}))